import { render, staticRenderFns } from "./specialImg_detail.vue?vue&type=template&id=cecd9876"
import script from "./specialImg_detail.vue?vue&type=script&lang=js"
export * from "./specialImg_detail.vue?vue&type=script&lang=js"
import style0 from "./specialImg_detail.vue?vue&type=style&index=0&id=cecd9876&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports